import type { SVGProps } from 'react'

export const FigmaMonochromeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    focusable={false}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.326 4.4H9.337c-1.098 0-1.989.926-1.989 2.067s.89 2.066 1.99 2.066h1.988V4.401Zm0-1.4h3.337C16.506 3 18 4.552 18 6.467c0 1.13-.52 2.134-1.326 2.766A3.508 3.508 0 0 1 18 12c0 1.915-1.494 3.467-3.337 3.467a3.24 3.24 0 0 1-1.989-.683V17.533c0 1.915-1.494 3.467-3.337 3.467C7.494 21 6 19.448 6 17.533c0-1.13.52-2.134 1.326-2.767A3.508 3.508 0 0 1 6 12c0-1.13.52-2.134 1.326-2.767A3.508 3.508 0 0 1 6 6.467C6 4.552 7.494 3 9.337 3h1.989Zm1.348 1.4v4.133h1.989c1.098 0 1.989-.925 1.989-2.066 0-1.141-.89-2.066-1.989-2.066h-1.989Zm-3.337 9.666h1.989V9.934H9.337c-1.098 0-1.989.925-1.989 2.066 0 1.138.886 2.062 1.981 2.066h.008Zm-1.989 3.467c0-1.138.886-2.062 1.981-2.066h1.997v2.066c0 1.141-.89 2.066-1.989 2.066-1.098 0-1.989-.925-1.989-2.066Zm5.326-5.537c.002-1.14.892-2.062 1.989-2.062 1.098 0 1.989.925 1.989 2.066 0 1.141-.89 2.066-1.989 2.066-1.097 0-1.987-.923-1.989-2.062v-.008Z"
      clipRule="evenodd"
    />
  </svg>
)
